/** Nome da meta no document.head com o nanoId da oferta (dedupe / analytics, sem depender da query string). */
export const OFFER_NANO_ID_META_NAME = 'td-offer-nano-id';

export function setOfferNanoIdMeta(nanoId: string | undefined | null): void {
  const id = String(nanoId ?? '').trim();
  if (!id || typeof document === 'undefined') return;
  let el = document.querySelector(`meta[name="${OFFER_NANO_ID_META_NAME}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', OFFER_NANO_ID_META_NAME);
    document.head.appendChild(el);
  }
  el.setAttribute('content', id);
}
